export default __webpack_public_path__ + "static/media/cashregister.5dd4fbe7.svg";